import { login, logoutUser, getInfo, getNavigationMenu } from "@/api/user";
import { getAreaList } from "@/api/project";

import { getToken, setToken, removeToken } from "@/utils/auth";
import { resetRouter } from "@/router";

const getDefaultState = () => {
  return {
    token: getToken(),
    name: "",
    avatar: "",
    menus: [],
    // 存储用户所有信息 不影响之前的参数
    userInfoData: null,
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_MENUS: (state, menus) => {
    state.menus = menus;
  },
  SET_USER_INFO_DATA: (state, userInfoData) => {
    state.userInfoData = userInfoData;
  }
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { mobile, password, login_type, verify_code } = userInfo;
    return new Promise((resolve, reject) => {
      login({ mobile: mobile.trim(), password: password, login_type: login_type, verify_code: verify_code })
        .then((response) => {
          const { data } = response;
          localStorage.setItem("userInfo", JSON.stringify(data.user));
          localStorage.removeItem("home");
          commit("SET_TOKEN", data.token);
          commit('SET_USER_INFO_DATA', data.user)
          setToken(data.token);
          // localStorage.setItem("org_id", data.user.org_id);
          // commit("SET_NAME", data.user.name);
          // commit("SET_AVATAR", data.user.avatar);
          getAreaList().then((res) => {
            localStorage.setItem("areaList", JSON.stringify(res.data));
          });
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 储存用户信息
  userInfo({ commit }, state) {
    return new Promise((resolve, reject) => {
      localStorage.setItem("userInfo", JSON.stringify(state.user));
      localStorage.removeItem("home");
      commit("SET_TOKEN", state.token);
      commit('SET_USER_INFO_DATA', state.user)
      setToken(state.token);
    });
  },
  // get user info
  // getInfo({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     getInfo(state.token)
  //       .then(response => {
  //         const { data } = response;

  //         if (!data) {
  //           return reject("Verification failed, please Login again.");
  //         }

  //         const { name, avatar } = data;
  //         commit("SET_NAME", name);
  //         commit("SET_AVATAR", avatar);
  //         resolve(data);
  //       })
  //       .catch(error => {
  //         reject(error);
  //       });
  //   });
  // },
  // 修改用户头像和昵称
  amendInfo({ commit }, state) {
    return new Promise((resolve, reject) => {
      commit(
        "SET_NAME",
        state.username && state.username != "" ? state.username : state.nickname
      );
      commit("SET_AVATAR", state.avatar);
    });
  },
  // 获取左侧菜单
  getAntRouter({ commit, state }) {
    return new Promise((resolve, reject) => {
      getNavigationMenu()
        .then((response) => {
          const { data } = response;
          if (!data) {
            reject("验证失败，请重新登录");
          }
          const menus = data;
          console.log("-----------左侧菜单栏");
          console.log(menus);
          // menus.push({
          //   path: "/accountSeeting/index",
          //   meta: {
          //     title: "账户设置",
          //     icon: "zhanghu"
          //   }
          // });
          commit("SET_MENUS", menus);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      try {
        logoutUser().then(() => {
          removeToken(); // must remove  token  first
          resetRouter();
          commit("RESET_STATE");
          dispatch("tagsView/delAllViews", null, { root: true });
          localStorage.removeItem("userInfo");
          localStorage.removeItem("home");
          localStorage.removeItem("vuex");
          setToken('')
          resolve();
        }).catch((err) => {
          reject(err);
        })
      } catch (error) {
        reject(error);
      }
      // logout(state.token)
      //   .then(() => {
      //     removeToken(); // must remove  token  first
      //     resetRouter();
      //     commit("RESET_STATE");
      //     dispatch("tagsView/delAllViews", null, { root: true });
      //     localStorage.removeItem("userInfo");
      //     localStorage.removeItem("home");
      //     setToken('')
      //     resolve();
      //   })
      //   .catch((error) => {
      //     reject(error);
      //   });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("menus");
      localStorage.removeItem("vuex");
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
